
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/steelbuildingestimates",
      function () {
        return require("private-next-pages/steelbuildingestimates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/steelbuildingestimates"])
      });
    }
  